<script lang="ts">
import {Component, Prop, Watch} from "vue-property-decorator";
import HelpPopup from "@/components/HelpPopup.vue";
import SearchComponent from "@/components/SearchComponent.vue";
import {Drug, DrugStatus} from "@/models/Drug/Drug";
import HasLabel from "@/models/HasLabel";
import {DrugSource} from "@/models/Drug/DrugProduct";
import Axios from "axios";

@Component({
    name: "SearchPrescriptionDetailComponent",
    components: {HelpPopup},
})
export default class SearchPrescriptionDetailComponent extends SearchComponent {
    @Prop({default: null}) private equivalentDrugs!: Drug.EquivalentDrug[];
    private mockOptionLabel!: Function | undefined;

    printLabel(o: any, long: boolean = false) {
        if (o.id == 0 && this.createNewObject) return this.createNewLabel;
        o = this.toModelType(o);
        if (this.mockOptionLabel && this.equivalentDrugs.length > 0) return this.mockOptionLabel(o);
        if (this.optionLabel) return this.optionLabel(o);
        else if (o instanceof HasLabel) return this.toModelType(o).getLabel(long);
        else return o ? o.id : "";
    }

    @Watch('equivalentDrugs') onEquivalentDrugsChange() {
        if (this.equivalentDrugs.length > 0) {
            this.addObject(this.equivalentDrugs);
            this.mockOptionLabel = (e: any) => {
                let label = `NDC: ${e.ndc} - Name: ${e.productNameShort} - PS: ${e.packageSize} - Marketer: ${e.marketer}`;
                if (e.quantityOnHand !== undefined && e.quantityOnHand !== null) {
                    label += ` - QTY: ${e.quantityOnHand}`;
                }
                if (e.lastPurchasePrice !== undefined && e.lastPurchasePrice !== null) {
                    label += ` - Last: $${e.lastPurchasePrice.toFixed(2)}`;
                }
                if (e.averageCost90Days !== undefined && e.averageCost90Days !== null) {
                    label += ` - Avg90d: $${e.averageCost90Days.toFixed(2)}`;
                }
                return label;
            };
            this.focus();
        }
    }

    public addObject(newObjects: Drug.EquivalentDrug[]) {

        const transformedDrugs = newObjects.map(eq => ({
            source: (eq as any).source ?? DrugSource.GsddFederal, // Respect source if provided, default to GSDD for backward compatibility
            drugId: eq.packageID ?? 0,
            ndc: eq.ndc ?? "",
            marketer: eq.marketer ?? "",
            packageSize: eq.packageSize ?? 0,
            productNameShort: eq.productNameLong ?? "",
            activeStatus: eq.activeStatus ?? DrugStatus.DrugStatusEnum.Active,
            licenseType: "",
            billingUnit: "",
            quantityOnHand: eq.onHand ?? 0,
            lastPurchasePrice: eq.lastPurchasePrice,
            averageCost90Days: eq.averageCost90Days
        }));

        const models = transformedDrugs.map((o) => this.toModelType(o));

        this.objects = [];
        models.forEach(m => {
            if (!this.objects.some(o => o.id === m.id)) {
                this.objects.push(m);
            }
        });
    }

    forceReload(value: any) {
        const url = this.getByIdURL || this.searchURL;

        const dropdown: any = this.$refs.dropdown;
        const toggleLoading = dropdown?.toggleLoading;

        // Latest-wins guard (shares reloadSeq with the base SearchComponent):
        // ignore a stale GET /{id} response so a slow reload can't replace a
        // drug the user just selected via Enter or Tab.
        const seq = ++this.reloadSeq;

        if (toggleLoading) toggleLoading(true);
        Axios.get(`${url}/${value.id}`, {params: this.paramsInGetById})
            .then((response) => {
                if (seq !== this.reloadSeq) return;
                this.object = this.toModelType(response.data);
            })
            .catch((error) => {
                console.warn(error);
            })
            .finally(() => {
                if (seq === this.reloadSeq && toggleLoading) toggleLoading(false);
                this.mockOptionLabel = undefined;
            });
    }
}

</script>
